import React, { useState, useEffect } from "react";
import {
  useDispatch, connect, useSelector
} from "react-redux";
import {
  Row, Col, Card, CardBody, 
  CardTitle, CardHeader, 
  Dropdown, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown
} from "reactstrap";
import {
  Table, Thead, Tbody, Tr, Th, Td
} from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
// i18n
import { withTranslation } from "react-i18next";
import CustomPagination from "components/Common/CustomPagination";
import TableLoader from "components/Common/TableLoader";
import { 
  fetchClientWithdrawals, withdrawApproveStart, withdrawRejectStart 
} from "store/transactions/withdrawal/action";
import {
  depositRejectStart, 
  depositApproveStart,
  fetchClientDeposits  
} from "store/transactions/deposit/action";
import { captilazeFirstLetter } from "common/utils/manipulateString";
import formatDate from "helpers/formatDate";
import Badge from "components/Common/Badge";
import CustomDropDown from "components/Common/CustomDropDown";


function ClientTransactions(props) {

  const clientId = props.clientId;
  const [sizePerPage, setSizePerPage] = useState(10);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedTransactionType, setSelectedTransactionType] = useState("Withdrawal");
  const transactionTypes = ["Withdrawal", "Deposit"];
  const dispatch = useDispatch();
  const { userData } = useSelector((state) => ({
    userData: state.Profile.userData,
  }));
  const { actions } = useSelector((state) => state.Profile.depositsPermissions);
  const changeTransactionTypeHandler = (e) => {
    setSelectedTransactionType(e.target.innerText);
  };

  const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

  const loadClientTransactions = () => {
    dispatch(fetchClientDeposits({ 
      clientId,
      type: "LIVE" 
    }));
    dispatch(fetchClientWithdrawals({ 
      clientId,
      type: "LIVE"
    }));
  };
  useEffect(() => {
    loadClientTransactions();
  }, [selectedTransactionType, props.depositClearingCounter, props.withdrawClearingCounter]);

  const depositApprove = (deposit)=>{
    dispatch(depositApproveStart({
      id: deposit._id,
      customerId: deposit.customerId._id 
    }));
  };
  const depositReject = (deposit)=>{
    dispatch(depositRejectStart({
      id: deposit._id,
      customerId: deposit.customerId._id 
    }));
  };
  const withdrawApprove = (withdrawal) => {
    dispatch(withdrawApproveStart({
      id: withdrawal._id,
      customerId: withdrawal.customerId._id 
    }));
  };

  const withdrawReject = (withdrawal) => {
    dispatch(withdrawRejectStart({
      id: withdrawal._id,
      customerId: withdrawal.customerId._id 
    }));
  };

  const columns = [
    {
      dataField: "checkbox",
      text: <input type="checkbox"/>
    },
    {
      dataField: "createdAt",
      text: props.t("Date"),
      formatter: (val) => formatDate(val.createdAt)
    }, 
    {
      dataField: "customerId",
      text: props.t("Client"),
      formatter:(val)=>(val.customerId ? `${captilazeFirstLetter(val.customerId?.firstName)} ${captilazeFirstLetter(val.customerId?.lastName)}` : "")
    },
    {
      dataField: "gateway",
      text: props.t("Gateway"),
      formatter: (val) => (val.gateway == "WIRE_TRANSFER" ? "Wire" : val.gateway?.split("_").join(" ")?.toLowerCase())
    },
    {
      dataField: "currency",
      text: props.t("Currency")    
    },
    selectedTransactionType === "Deposit" && {
      dataField: "to",
      text: props.t("To"),
      formatter: (val) => (
        val.to?.length >= 10 ? val.to.substr(0, 4) + "....." + val.to.substr(-5, 4) : val.to
      )
    },
    selectedTransactionType === "Withdrawal" && {
      dataField: "from",
      text: props.t("From"),
      formatter: (val) => (
        val.from?.length >= 10 ? val.from.substr(0, 4) + "....." + val.from.substr(-5, 4) : val.from
      )
    },
    {
      dataField: "status",
      text: props.t("Status"),
      formatter: (val) => <Badge status={val.status}></Badge>,
    },
    {
      dataField: "reason",
      text: props.t("Reason"),
      formatter: (item) => (
        item.reason ? item.reason : "-"
      )
    },
    {
      dataField: "amount",
      text: props.t("Amount"),
      formatter: (item) => (
        parseFloat(item?.amount?.$numberDecimal)?.toFixed(2) || parseFloat(item?.amount)?.toFixed(2) || "-"
      )
    },
    {
      dataField: "note",
      text: props.t("note"),
      formatter: (item) => (
        item?.note?.length === 0 ? "-" : captilazeFirstLetter(item?.note)
      )
    },
    selectedTransactionType === "Deposit" &&
    {
      dataField: "",
      isDummyField: true,
      editable: false,
      text: props.t("Actions"),
      formatter: (item) =><CustomDropDown
        status={item.status}
        approve={() => depositApprove(item)}
        reject={() => depositReject(item)}
        permission={actions}
      />
    },
    selectedTransactionType === "Withdrawal" &&
    {
      dataField: "",
      isDummyField: true,
      editable: false,
      text: props.t("Actions"),
      formatter: (item) => <CustomDropDown
        status={item.status}
        approve={() => withdrawApprove(item)}
        reject={() => withdrawReject(item)}
        permission={actions}
      /> 
    },
  ];

  return (
    <React.Fragment>
      <div className="">
        <div className="container-fluid">
          <Row>
            <Col className="col-12">
              <Card>
                <CardHeader className="d-flex justify-content-between  align-items-center">
                  <CardTitle className="color-primary">
                    {props.t("Transactions list")} ({selectedTransactionType === "Withdrawal" ? props.withdrawalsTotalDocs : props.depositsTotalDocs})
                  </CardTitle>
                  <Dropdown
                    isOpen={isDropdownOpen}
                    toggle={toggleDropdown}
                  >
                    <DropdownToggle tag="button" className="btn btn-primary">
                      {selectedTransactionType} <i className="mdi mdi-chevron-down" />
                    </DropdownToggle>
                    <DropdownMenu>
                      {transactionTypes.map((transactionType) => (
                        <DropdownItem 
                          key={transactionTypes.indexOf(transactionType)}
                          onClick={(e) => {changeTransactionTypeHandler(e)}}
                        >
                          {props.t(transactionType)}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  </Dropdown>
                </CardHeader>
                <CardBody>
                  <div className="table-rep-plugin">
                    <div
                      className="table-responsive mb-0"
                      data-pattern="priority-columns"
                    >
                      <Table
                        id="tech-companies-1"
                        className="table  table-hover "
                      >
                        <Thead className="text-center table-light" >
                          <Tr>
                            { userData.role !== "Sales" ? (
                              columns.map((column, index) =>
                                <Th data-priority={index} key={index}><span className="color-primary">{column.text}</span></Th>
                              )

                            ) : (
                              columns.filter((col) => col.text !== "Actions").map((column, index) =>
                                <Th data-priority={index} key={index}><span className="color-primary">{column.text}</span></Th>
                              )
                            )
                            }
                          </Tr>
                        </Thead>
                        {/* if no records show "No records" otherwise show records */}
                        {
                          // if deposits is selected then render clientDeposits
                          selectedTransactionType === "Deposit"
                            ?
                            // if deposits is selected but no data to show
                            props.depositsTotalDocs === 0 
                              ?
                              <Tbody>
                                {props.loading && <TableLoader colSpan={4} />}                            
                                {!props.loading && /*props.totalDocs === 0 && */
                                  <>
                                    <Tr>
                                      <Td colSpan={"100%"} className="fw-bolder text-center" st="true">
                                        <h3 className="fw-bolder text-center">No records</h3>
                                      </Td>
                                    </Tr>
                                  </>
                                }
                              </Tbody>
                              :
                              // if deposits is selected and there is data to show
                              <Tbody style = {{
                                fontSize: "12px",
                                textAlign: "center",
                                textTransform: "capitalize"
                              }}>
                                {props.loading && <TableLoader colSpan={4} />}
                                {!props.depositLoading && props.clientDeposits.map((row, rowIndex) =>
                                  <Tr key={rowIndex}>
                                    { userData.role !== "Sales" ? (
                                      columns.map((column, index) =>
                                        <Td key={`${rowIndex}-${index}`}>
                                          { column.dataField === "checkbox" ? <input type="checkbox"/> : ""}
                                          { column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                                        </Td>
                                      )

                                    ) : (
                                      columns.filter((col) => col.text !== "Actions").map((column, index) =>
                                        <Td key={`${rowIndex}-${index}`}>
                                          { column.dataField === "checkbox" ? <input type="checkbox"/> : ""}
                                          { column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                                        </Td>
                                      )
                                    )
                                    }
                                  </Tr>
                                )}
                              </Tbody>
                            :
                            // if withdrawals is selected 
                            props.withdrawalsTotalDocs === 0 
                              ?
                              // if withdrawals is seleceted but no data to show
                              <Tbody>
                                {props.loading && <TableLoader colSpan={4} />}  
                                {!props.withdrawalLoading &&
                                  <>
                                    <Tr>
                                      <Td colSpan={"100%"} className="fw-bolder text-center" st="true">
                                        <h3 className="fw-bolder text-center">No records</h3>
                                      </Td>
                                    </Tr>
                                  </>
                                }
                              </Tbody>
                              :
                              // if withdrawals is selected and there is data to show
                              <Tbody style = {{
                                fontSize: "12px",
                                textAlign: "center",
                                textTransform: "capitalize"
                              }}>
                                {props.loading && <TableLoader colSpan={4} />}
                                {(!props.loading && props.clientWithdrawals) && props.clientWithdrawals.map((row, rowIndex) =>
                                  <Tr key={rowIndex}>
                                    { userData.role !== "Sales" ? (
                                      columns.map((column, index) =>
                                        <Td key={`${rowIndex}-${index}`}>
                                          { column.dataField === "checkbox" ? <input type="checkbox"/> : ""}
                                          { column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                                        </Td>
                                      )

                                    ) : (
                                      columns.filter((col) => col.text !== "Actions").map((column, index) =>
                                        <Td key={`${rowIndex}-${index}`}>
                                          { column.dataField === "checkbox" ? <input type="checkbox"/> : ""}
                                          { column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                                        </Td>
                                      )
                                    )
                                    }
                                  </Tr>
                                )}
                              </Tbody>
                        }
                      </Table>
                      {/* if deposits is selected */}
                      {
                        (props.clientDeposits && selectedTransactionType === "Deposit") && 
                        <CustomPagination
                          {...props}
                          docs={props.clientDeposits}
                          totalDocs={props.depositsTotalDocs}
                          setSizePerPage={setSizePerPage}
                          sizePerPage={sizePerPage}
                          onChange={loadClientTransactions}
                        />
                      }
                      {
                        (props.clientWithdrawals && selectedTransactionType === "Withdrawal") && 
                        <CustomPagination
                          {...props}
                          totalDocs={props.withdrawalsTotalDocs}
                          setSizePerPage={setSizePerPage}
                          sizePerPage={sizePerPage}
                          onChange={loadClientTransactions}
                        />
                      }
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  depositLoading: state.depositReducer.loading,
  withdrawalLoading: state.withdrawalReducer.loading,
  error: state.clientReducer.error,
  clientDeposits: state.depositReducer.clientDeposits,
  clientWithdrawals: state.withdrawalReducer.clientWithdrawals,
  errorDetails: state.clientReducer.errorDetails,
  depositsTotalDocs: state.depositReducer.depositsTotalDocs,
  withdrawalsTotalDocs: state.withdrawalReducer.withdrawalsTotalDocs,
  depositResponseMessage: state.depositReducer.depositResponseMessage,
  depositChangeStatusSuccess: state.depositReducer.depositChangeStatusSuccess,
  depositClearingCounter: state.depositReducer.clearingCounter,
  withdrawClearingCounter: state.withdrawalReducer.clearingCounter,
});

export default connect(mapStateToProps, null)(withTranslation()(ClientTransactions));
